import { NextRouter } from 'next/router';

export const simplifyUrl = (urlWithBase: string, { locale }: NextRouter) => {
  const baseUrl = process.env.NEXT_PUBLIC_APP_BASE_URL || '';
  const basePath = baseUrl ? new RegExp(`^${baseUrl}`) : '';
  const localePath = locale ? new RegExp(`^/${locale}`) : '';
  return urlWithBase.replace(basePath, '').replace(localePath, '') || '/';
};
